<script>
    export let item;
    const locale = localStorage.getItem('locale');

    function getPeriod(start, end, current){
        const dateStart = new Date(start).toLocaleDateString(locale, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        let output = dateStart;

        if ( current === true ) {
            output += " - " + end;
        } else {
            const dateEnd = new Date(end).toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            output += " - " + dateEnd;
        }

        return output;
    }
</script>

<div class="bg-white">
    <div class="container mx-auto p-6">
        <div class="grid grid-cols-1">
            <div class="hidden md:flex md:flex-row">
                <div class="basis-2/3 p-4 text-zinc-900">
                    <p class="text-2xl pb-2">{item.position}</p>
                    <p class="">{item.company}</p>
                    <p class="">{getPeriod(item.period.start, item.period.end, item.period.current)}</p>
                    <p class="pb-6 text-sm">{item.location}</p>
                </div>
                <a href="{item.image.link}" target="_blank" rel="noreferrer" class="basis-1/3 grid grid-cols-1 place-content-center">
                    <picture class="p-4 place-self-center">
                        <source
                            srcset="{item.image.path}_x96.heic"
                            type="image/heic"
                        />
                        <source
                            srcset="{item.image.path}_x96.avif"
                            type="image/avif"
                        />
                        <source
                            srcset="{item.image.path}_x96.webp"
                            type="image/webp"
                        />
                        <img alt="{item.image.name}" src="{item.image.path}_x96.png"/>
                    </picture>
                </a>
            </div>
            <div class="grid md:hidden">
                <a href="{item.image.link}" target="_blank" rel="noreferrer" class="place-self-center">
                    <picture class="p-4 place-self-center">
                        <source
                            srcset="{item.image.path}_x96.heic"
                            type="image/heic"
                        />
                        <source
                            srcset="{item.image.path}_x96.avif"
                            type="image/avif"
                        />
                        <source
                            srcset="{item.image.path}_x96.webp"
                            type="image/webp"
                        />
                        <img alt="{item.image.name}" src="{item.image.path}_x96.png"/>
                    </picture>
                </a>
                <div class="p-4 text-zinc-900">
                    <p class="text-2xl pb-2">{item.position}</p>
                    <p class="">{item.company}</p>
                    <p class="">{getPeriod(item.period.start, item.period.end, item.period.current)}</p>
                    <p class="pb-6 text-sm">{item.location}</p>
                </div>
            </div>
            <p class="p-4 text-zinc-900">{item.description}</p>
        </div> 
    </div>
</div>